module.exports = __webpack_public_path__ + "img/蓝莓1.55be1580.png";